import { TeacherSearchResultsGuard } from './teacher-searchresults.guard';
import { TeacherDetailsExistsGuard } from './teacher-details-exists.guard';

export const guards: any[] = [TeacherSearchResultsGuard, TeacherDetailsExistsGuard];

export * from './teacher-searchresults.guard';
export * from './teacher-details-exists.guard';
